import type { Address } from 'viem'

import type { HistoryRange } from '@/lib/transforms/history/window'

import { orpc } from '@/lib/orpc/client'

/** Above 0 so a history prefetched on the server is not refetched as soon as it hydrates. */
const APY_HISTORY_STALE_TIME_MS = 60_000

export const apyHistoryQueryOptions = (input: {
  chainId: number
  address: Address
  range: HistoryRange
}) => orpc.vaultV1.apyHistory.queryOptions({ input, staleTime: APY_HISTORY_STALE_TIME_MS })
